import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {UrlService} from '../url.service';

@Injectable()
export class EnrollmentService {
    private readonly BASE_URL: string;

    constructor(private http: HttpClient,
                private urlService: UrlService) {
        this.BASE_URL = this.urlService.getBackendUrl() + 'data/clients';
    }

    // Get all the document types from the database.
    getEnrollmentCodesForDisplay() {
        // Not returned as a promise at the moment.  Probably should be or at least gotten
        // out of the config.
        return ['CFS'];
    }

    getEnrollments(clientId) {
        return this.http.get(this.BASE_URL + '/' + clientId + '/enrollments');
    }
}
